/**
 * Template: Page - Contact
 * ------------------------------------------------------------------------------
 */
import {load} from '@shopify/theme-sections';
import {on} from '~/helpers/utils';
import '../../styles/templates/page.contact.scss';

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  const conctactForm = document.querySelector('#contact_form');

  on('submit', conctactForm, () => {
    window.dataLayer.push({
      event: 'GAevent',
      eventID: '20',
      eventCategory: 'contact_us',
      eventAction: 'inquiries_form',
      eventLabel: 'form_send',
    });
  });
});
